<a
  *ngIf="personId"
  class="phone-btn person-box-shadow"
  [href]="zypnoLink | safeUrl"
  ngbTooltip="{{ 'Open ZyDesk' | translate }}"
  >
    <fa-icon [icon]="'phone'"></fa-icon>
</a>
